import { render, staticRenderFns } from "./languedoc-roussillon.vue?vue&type=template&id=22dd1da5&scoped=true"
import script from "./languedoc-roussillon.vue?vue&type=script&lang=js"
export * from "./languedoc-roussillon.vue?vue&type=script&lang=js"
import style0 from "./languedoc-roussillon.vue?vue&type=style&index=0&id=22dd1da5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd1da5",
  null
  
)

export default component.exports